import { useTranslation } from 'react-i18next'
import { BadgeCheck } from 'lucide-react'

interface CommunityPostAuthorLabelProps {
  readonly authorDisplayName: string
  readonly showVerifiedArtistCheckmark: boolean
  readonly className?: string
}

export function CommunityPostAuthorLabel({
  authorDisplayName,
  showVerifiedArtistCheckmark,
  className = '',
}: CommunityPostAuthorLabelProps) {
  const { t } = useTranslation()

  return (
    <p className={`inline-flex min-w-0 items-center gap-1 text-xs ${className}`.trim()}>
      <span className="truncate font-medium text-foreground/90">{authorDisplayName}</span>
      {showVerifiedArtistCheckmark && (
        <BadgeCheck
          className="h-3.5 w-3.5 shrink-0 text-blue-500"
          aria-label={String(t('board.verifiedArtistAria'))}
        />
      )}
    </p>
  )
}
